<template>
    <div>
        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper class="flex-grow-1 flex-shrink-1 flex-basis-45">
                    <span>
                        {{ $t('§users.invite_email_address') }}
                    </span>
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreStringInput
                    v-model="invite_email"
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    placeholder="§ui.placeholder_input_email"
                    :disabled="true"
                />
            </template>
        </CoreTwoColumnsRow>

        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper class="flex-grow-1 flex-shrink-1 flex-basis-45">
                    <span>
                        {{ $t('§users.invite_created_at') }}
                    </span>
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreStringInput
                    v-model="invite_created_at"
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    placeholder="§ui.placeholder_created_at"
                    :disabled="true"
                />
            </template>
        </CoreTwoColumnsRow>

        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper class="flex-grow-1 flex-shrink-1 flex-basis-45">
                    <span>
                        {{ $t('§users.valid_until') }}
                    </span>
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreStringInput
                    v-model="validUntil"
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    placeholder="§ui.placeholder_valid_until"
                    :disabled="true"
                />
            </template>
        </CoreTwoColumnsRow>

        <CoreTwoColumnsRow>
            <template #left>
                <CoreBorderWrapper class="flex-grow-1 flex-shrink-1 flex-basis-45">
                    <span>
                        {{ $t('§users.invitation_link') }}
                    </span>
                </CoreBorderWrapper>
            </template>
            <template #right>
                <CoreStringInput
                    v-model="invitationLink"
                    class="flex-grow-1 flex-shrink-1 flex-basis-55"
                    placeholder="§ui.placeholder_invitation_link"
                    :disabled="true"
                />
            </template>
        </CoreTwoColumnsRow>

        <div class="mt-4 flex justify-start gap-2">
            <CoreButton
                label="§ui_button.resend_invite"
                icon="pi-refresh"
                @click="handleInviteResend"
                :loading="usersStore.loading"
                :disabled="!invite_expired || !!invite_accepted || usersStore.loading"
            />

            <CoreButton
                label="§ui_button.delete"
                class="p-button-danger"
                variant="danger"
                :disabled="isDeleteButtonDisabled"
                @click="handleDelete"
                icon="pi-trash"
            />

            <CoreButton
                icon="pi-times"
                label="§ui_button.cancel"
                variant="tertiary"
                :disabled="usersStore.deleting"
                @click="handleClose"
            />
        </div>
    </div>
</template>

<script>
import { useUsersStore } from '@/stores/users'
import { useModalStore } from '@/stores/modal'
import CoreTwoColumnsRow from '@/components/core/CoreTwoColumnsRow.vue'
import CoreBorderWrapper from '@/components/core/CoreBorderWrapper.vue'
import CoreStringInput from '@/components/core/CoreStringInput.vue'
import CoreButton from '@/components/core/CoreButton.vue'

export default {
    name: 'InviteItemModal',

    components: {
        CoreTwoColumnsRow,
        CoreBorderWrapper,
        CoreStringInput,
        CoreButton,
    },

    data() {
        return {
            usersStore: useUsersStore(),
            modalStore: useModalStore(),

            id: null,
            invite_email: null,
            invite_created_at: null,
            validUntil: null,
            invite_expired: null,
            invite_accepted: null,
            invitationLink: null,
            user_id: null,
            user_email: null,
            user_name: null,
        }
    },

    computed: {
        isDeleteButtonDisabled() {
            return !(!this.invite_accepted && this.invite_expired) || this.usersStore.deleting
        },
    },

    mounted() {
        this.handleData({ ...this.modalStore.data })
    },

    methods: {
        handleClose() {
            this.modalStore.setClose()
        },

        handleData(data) {
            this.id = data.id
            this.invite_email = data.invite_email
            this.invite_created_at = data.invite_created_at
            this.invite_email = data.invite_email
            this.invite_created_at = data.invite_created_at
            this.validUntil = data.validUntil
            this.invite_expired = data.invite_expired
            this.invite_accepted = data.invite_accepted
            this.invitationLink = data.token
                ? `${window.location.origin}/invited/${data.token}`
                : ''
            this.user_id = data.user_id
            this.user_email = data.user_email
            this.user_name = data.user_name
        },

        callCopyOrSelectAction(propName) {
            if (navigator.clipboard) {
                this.copyToClipboard(propName)
            } else {
                this.$refs.invite.select()
            }
        },

        async copyToClipboard(propName) {
            const triggerNotification = (notification) => {
                this.showNotification(notification)
            }

            const isAllowed = await this.checkClipboardPermission()

            if (isAllowed) {
                navigator.clipboard.writeText(this[propName]).then(
                    function () {
                        triggerNotification({
                            type: 'success',
                            text: 'notifications.success_clipboard_copy',
                        })
                    },
                    function () {
                        triggerNotification({
                            type: 'error',
                            text: 'notifications.error_clipboard_copy',
                        })
                    }
                )
            }
        },

        checkClipboardPermission() {
            // firefox has clipboard-write permission true by default
            if (navigator.userAgent.indexOf('Firefox') > -1) {
                return true
            }

            // safari does not support permission API
            if (navigator.userAgent.indexOf('Safari') > -1) {
                return true
            }

            const result = navigator.permissions.query({
                name: 'clipboard-write',
            })

            return result
        },

        handleInviteResend() {
            this.usersStore.resendInvite(this.id)
            this.handleClose()
        },

        handleDelete() {
            this.usersStore.deleteInvite({ id: this.id })
            this.handleClose()
        },
    },
}
</script>
